// src/pages/Catalog/components/ProductCardSkeleton.js
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardContent, CardActions } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  media: {
    height: 200,
  },
  content: {
    flexGrow: 1,
  },
  actions: {
    justifyContent: "flex-end",
    paddingTop: 0,
  },
}));

const ProductCardSkeleton = () => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <Skeleton animation="wave" variant="rect" className={classes.media} />
      <CardContent className={classes.content}>
        <Skeleton animation="wave" height={32} style={{ marginBottom: 6 }} />
        <Skeleton animation="wave" height={20} width="80%" />
        <Skeleton animation="wave" height={20} width="40%" style={{ marginTop: 12 }} />
        <Skeleton animation="wave" height={32} width="60%" style={{ marginTop: 12 }} />
      </CardContent>
      <CardActions className={classes.actions}>
        <Skeleton animation="wave" variant="circle" width={32} height={32} style={{ marginLeft: 8 }} />
        <Skeleton animation="wave" variant="circle" width={32} height={32} style={{ marginLeft: 8 }} />
      </CardActions>
    </Card>
  );
};

export default ProductCardSkeleton;